export class Dewey {
  _id: string;
  liv01: string;
  liv02: string;
  liv03: string;
  liv04: string;
  label: string;
  deweyCodice: string;
  deweyEdizione: string;
  deweyDescrittore: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Dewey.ts